//Built-in libraries

//Third party libraries

//Custom components
import { HookInput } from 'components/UI/HookForm/Form/Input';
import { HookSelect } from 'components/UI/HookForm/Form/Select';
import HookMaskedInput from 'components/UI/HookForm/Form/MaskedInput';
import { HookCheckboxGroup } from 'components/UI/HookForm/Form/CheckBoxGroup';
import Button from 'components/UI/Button';

//Services
import { useApplicationFormContext } from 'features/ApplicationForm/ApplicationFormProvider';

//STP Libraries

//Assets and Miscellaneous
import { States } from '../../../../../../constants';
import { anyApply } from './constant';

//Component Begin

export default function ApplicantInformation() {
  const { setCurrentStep } = useApplicationFormContext();

  return (
    <div className='sm:rounded-r-md sm:overflow-hidden'>
      <div className='py-6 px-4 space-y-6 sm:p-6'>
        <h3 className='text-lg leading-6 font-medium text-green-500'>
          Applicant Information
        </h3>
        <div className='grid grid-cols-6 gap-6'>
          <HookInput
            customClassName='col-span-3'
            label='Entity Name'
            name='applicantInformation.entityName'
            type='text'
          />
          <HookMaskedInput
            customClassName='col-span-6 sm:col-span-3'
            label='EIN'
            name='applicantInformation.ein'
            id='ein'
            maskedComponent='ein'
          />
          <HookInput
            customClassName='col-span-6 sm:col-span-3'
            label='Contact Person Full Name'
            name='applicantInformation.contactPersonName'
            type='text'
          />
          <HookInput
            customClassName='col-span-6 sm:col-span-3'
            label='Contact Person Email'
            name='applicantInformation.contactPersonEmail'
            type='email'
            placeholder='myemail@example.com'
          />
          <HookInput
            customClassName='col-span-6'
            label='Street Address'
            name='applicantInformation.streetAddress'
            type='text'
          />
          <HookInput
            customClassName='col-span-6 sm:col-span-6 lg:col-span-2'
            label='City'
            name='applicantInformation.city'
            type='text'
          />
          <HookSelect
            customClassName='col-span-6 sm:col-span-3 lg:col-span-2'
            label='State / Province'
            name='applicantInformation.state'
            options={States.map((state) => ({
              label: state.name,
              value: state.name,
            }))}
          />

          <HookInput
            customClassName='col-span-6 sm:col-span-6 lg:col-span-2'
            label='ZIP / Postal code'
            name='applicantInformation.zipCode'
            type='number'
          />
          <HookMaskedInput
            customClassName='col-span-6 sm:col-span-6 lg:col-span-2'
            label='Phone Number'
            name='applicantInformation.phone'
            id='phone'
            maskedComponent='phone'
          />
          <HookInput
            customClassName='col-span-6 sm:col-span-6 lg:col-span-2'
            label='Website (if available)'
            name='applicantInformation.website'
            type='text'
            placeholder='mywebsite.com'
          />
          <HookInput
            customClassName='col-span-6 sm:col-span-6 lg:col-span-2'
            label='Formation Date'
            name='applicantInformation.formationDate'
            type='date'
          />
          <HookInput
            customClassName='col-span-6 sm:col-span-6 lg:col-span-2'
            label='Number of Full Time Employees'
            name='applicantInformation.fullTimeEmployeeCount'
            type='number'
          />
        </div>
        <div>
          <HookCheckboxGroup
            label='Check any of the following that apply:'
            name='applicantInformation.anyApply'
            id='any-apply'
            options={anyApply.map((p) => ({
              label: p.label,
              value: p.label,
            }))}
          />
        </div>
        <div className='flex gap-4 justify-end mt-5'>
          <Button
            label='Previous'
            btnStyle='neutral'
            type='button'
            onClick={() => setCurrentStep((prev) => prev - 1)}
          />
          <Button label='Next' btnStyle='primary' type='submit' />
        </div>
      </div>
    </div>
  );
}
